import { Col } from 'antd'
import Input from 'components/Form/Input'
import { FilterText } from 'components/UIComponents/ReportSearchFilter/Style/style.js'
import { OptionData } from 'modules/Report/ExcelHeaderData.js'
import {
  CenterAlignment,
  DividerStyle,
  ErrorMessage,
  OptionWrapper,
  RankWrapper,
  RankingWrapper,
  StyledOption,
  StyledSelect,
} from 'modules/Report/Styles/Styles.js'
import React, { useEffect, useState } from 'react'
const Dividers = () => <DividerStyle />
const RankFilter = ({
  setClear,
  clear,
  setError,
  error,
  dataSign,
  setRank,
  setRankSign,
}) => {
  const [day, setDay] = useState(null)
  const [value, setValue] = useState('')
  useEffect(() => {
    setClear(false)
    setDay(null)
    setValue('')
    setError('')
    setRank('')
    setRankSign('')
  }, [clear])

  const handleDayChange = day => {
    setClear(false)
    setDay(day)
  }

  const handleInputChange = e => {
    const { value } = e.target
    setValue(value)
  }
  useEffect(() => {
    const pattern = /^(?:[1-4](?:\.\d+)?|0\.[1-9]|0\.0*[1-9]|5(?:\.0+)?)$/

    if (day && !value) {
      setError('Kindly update the value')
    } else if (value && !day) {
      if (pattern.test(value)) {
        setError('Kindly update the Range')
      } else {
        setError(
          'The value should be between 0.1 and 5, and it should have exactly one digit before and after the decimal point.'
        )
      }
    } else if (day && value) {
      if (pattern.test(value)) {
        if (day == '>' && value == 5) {
          setError('The highest rank value is 5 only')
          dataSign('')
          setRankSign('')
          setRank('')
        } else {
          let data = { rank: value, rankSign: day }
          dataSign(data)
          setError('')
        }
      } else {
        setError(
          'The value should be between 0.1 and 5, and it should have exactly one digit before and after the decimal point.'
        )
      }
    }
  }, [day, value])

  return (
    <CenterAlignment>
      <RankingWrapper>
        <Col span={12}>
          <FilterText>Range</FilterText>
        </Col>
        <Col span={12}>
          <FilterText>Rank</FilterText>
        </Col>
      </RankingWrapper>
      <RankingWrapper>
        <Col span={12}>
          <StyledSelect
            placeholder={`Range`}
            value={day}
            onChange={handleDayChange}
          >
            {OptionData?.map(({ name }) => (
              <OptionWrapper
                key={name}
                value={name}
                disabled={name == 'divider'}
              >
                {name == 'divider' ? (
                  <Dividers />
                ) : (
                  <StyledOption> {name}</StyledOption>
                )}
              </OptionWrapper>
            ))}
          </StyledSelect>
        </Col>
        <Col span={12}>
          <Input
            width="80%"
            placeholder="Rank"
            height="2.6rem"
            onChange={handleInputChange}
            value={value}
          />
        </Col>
      </RankingWrapper>
      <RankWrapper>
        <ErrorMessage>{error ? 'Note: ' + error : ''}</ErrorMessage>
      </RankWrapper>
    </CenterAlignment>
  )
}
export default RankFilter
